import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api_path } from "../shared";
import Select from "react-select";

import SidebarMenu from "../components/DashboardMenu";
import SalesPipelineComponent from "../components/Customer/SalesPipelineComponent";
import TotalActivityComponent from "../components/Customer/TotalActivityComponent";
import RecentActivityComponent from "../components/Customer/RecentActivityComponent";
import TodoListComponent from "../components/Customer/TodoListComponent";
import LostActivityComponent from "../components/Customer/LostActivityComponent";
import MentionedCommentsBox from "../components/Customer/MentionedCommentsBox";
import SalesReportComponent from "../components/Customer/SalesReportBIComponent";
import CustomerDashboardDatagrid from "../components/Customer/CustomerDashboardDatagrid";
import SalesActivityReportComponent from "../components/Customer/SalesActivityReportComponent";
import SalesCoReportComponent from "../components/Customer/SalesCoReportComponent";


export function SalesReport() {

  // ✅ Safe localStorage for Safari
  const safeParse = (key) => {
    try {
      const val = localStorage.getItem(key);
      if (!val || val === "undefined" || val === "null") return null;
      return JSON.parse(val);
    } catch {
      return null;
    }
  };
 //const getUserID = 73;//looknok
  const getUserID = safeParse("USER_ID");
  const getUserRole = safeParse("USER_ROLE_ID");
  const getUserEMail = safeParse("USER_EMAIL");
  const getEmpCode = safeParse("USER_EMPCODE");

  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const [accessToken, setAccessToken] = useState(null);
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState("");
  const [saleList, setSaleList] = useState([]);
  const [selectSale, setSelectSale] = useState(null);
  const [sale, setSale] = useState({});
  const [selectedStageId, setSelectedStageId] = useState(null);
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  // ✅ stage/activity mapping
  const stageMapping = {
    lead: 1,
    "in contact": 2,
    "quotation sent": 3,
    "closed - won": 6,
    "closed - lost": 7,
  };
  const activityMapping = {
    telesales: 1,
    "sales visit": 2,
    quotation: 3,
  };

  const handleStageClick = (stageName) => {
    const key = (stageName || "").trim().toLowerCase();
    setSelectedStageId(stageMapping[key] || null);
  };

  const handleActivityClick = (activityName) => {
    const key = (activityName?.type || "").trim().toLowerCase();
    setSelectedActivityId(activityMapping[key] || null);
  };

  // ✅ Auth - handle iOS popup login
  useEffect(() => {
    if (accounts && accounts.length > 0) {
      setName(accounts[0].name);
      getUserPhoto();
    }
  }, [accounts]);

  const getUserPhoto = async () => {
    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: accounts[0],
      });
      const graphResponse = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
        headers: { Authorization: `Bearer ${response.accessToken}` },
      });
      if (graphResponse.ok) {
        const blob = await graphResponse.blob();
        setPhoto(URL.createObjectURL(blob));
      }
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const popupResponse = await instance.acquireTokenPopup({ scopes: ["User.Read"] });
          const blob = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
            headers: { Authorization: `Bearer ${popupResponse.accessToken}` },
          }).then((r) => r.blob());
          setPhoto(URL.createObjectURL(blob));
        } catch (err) {
          console.warn("iOS popup login failed", err);
        }
      }
    }
  };

  // ✅ Safe fetch sale list
  const fetchSale = async () => {
    try {
      const response = await axios.get(`${api_path}/GET_SALES.php`, {
        params: { role: getUserRole, user: getUserID },
      });
      const saleData = response.data || [];
      setSaleList(saleData);
      if (saleData.length === 1) {
        setSelectSale(saleData[0].SALE_CODE);
        setSale(saleData[0]);
      }
    } catch (error) {
      console.error("Error fetching sales:", error);
    }
  };

  useEffect(() => {
    if (!getUserRole) {
      navigate("/login");
      return;
    }
    if (getUserRole == 1) {
      setSelectSale(getUserID);
      setSale({ SALE_CODE: getUserID, SALE_NAME: getUserEMail });
      fetchSale();
    } else {
      setSelectSale(getUserID);
      setSale({ SALE_CODE: getUserID, SALE_NAME: getUserEMail });
      fetchSale();
    }
  }, []);

  const handleSaleChange = (obj) => {
    if (obj) {
      setSelectSale(obj.SALE_CODE);
      setSale(obj);
    } else {
      setSelectSale(null);
      setSale({});
    }
  };

  // ✅ Guard: ถ้ายังไม่มีข้อมูล user เลย → ไม่ render อะไร (ป้องกัน crash iOS)
  if (!getUserID || !getUserRole) {
    return <div style={{ padding: 50, textAlign: "center" }}>Loading...</div>;
  }

  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
       
    
            <Grid item xs={12} sm={12}>
              <SalesCoReportComponent userId={selectSale} source="crm"/>
            </Grid>
          </Grid>

    </Container>
  );
}

// ✅ ใช้ Popup auth (รองรับ iPhone Safari)
export default function DashboardWithAuth() {
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  return (
    <MsalAuthenticationTemplate
      interactionType={isIOS ? InteractionType.Popup : InteractionType.Redirect}
      authenticationRequest={loginRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      {/* <SalesCoReportComponent /> */}
    </MsalAuthenticationTemplate>
  );
}
